import {handleLogout} from "components/utils";
import React, {forwardRef, useRef, useState} from 'react';
import {Button, Modal, OverlayTrigger, Tooltip} from "react-bootstrap";
import axios from "axios";
import {DiagnosticRecordUpdateView} from "./DiagnosticRecordUpdateView";
import {LabRecordUpdateView} from "./lab/LabRecordUpdateView";
import ReactToPrint from "react-to-print";
import {LabRecordPrintView} from "./lab/LabRecordPrintView";

export const DiagnosticRecordView = forwardRef((props: { record: any, fetchRecords: any, isActive: boolean, category: string, uhid: string, entityQr: string, referringDr: string, stateTracker: string }, ref) => {

    let componentRef = useRef(null);
    const handleRemove = () => {
        axios.get('/api/backend/customer/records/remove/' + props.record.id + "/" + props.record.data.key)
            .then(resp => {
                props.fetchRecords()
                console.log(JSON.stringify(resp.data))
            })
            .catch(err => {
                console.error(err);
                if (err.response && err.response!.status && err.response!.status === 403) {
                    handleLogout()
                }
            })
    };

    const [showUpdateRecordModal, setShowUpdateRecordModal] = useState(false);
    const [recordToBeUpdated, setRecordToBeUpdated] = useState(null);
    const handleCloseUpdateRecordModal = () => {
        setShowUpdateRecordModal(false);
        props.fetchRecords();
    }
    const handleShowUpdateRecordModal = (recordToBeUpdated) => {
        setRecordToBeUpdated(recordToBeUpdated)
        setShowUpdateRecordModal(true)
    }

    function getModalForUpdateRecord() {
        return <Modal
            show={showUpdateRecordModal}
            onHide={handleCloseUpdateRecordModal}
            backdrop="static"
            className="modal-xl"
        >
            <Modal.Header closeButton/>
            <Modal.Body>
                {props.category != "Lab" &&
                    <DiagnosticRecordUpdateView id={props.record && props.record.id} recordId={recordToBeUpdated}
                                                postAction={handleCloseUpdateRecordModal}
                                                status={props.record && props.record.reportStatus}/>}
                {props.category == "Lab" &&
                    <LabRecordUpdateView id={props.record && props.record.id} recordId={recordToBeUpdated}
                                         postAction={handleCloseUpdateRecordModal}
                                         status={props.record && props.record.reportStatus}/>}
            </Modal.Body>
        </Modal>;
    }

    const renderSmsTooltip = (props) => (
        <Tooltip id="sms-tooltip" {...props}>
            Send report to Patient
        </Tooltip>
    );


    const handleSendDigital = () => {
        axios.post('/api/backend/direct/link/create/' + props.record.uhid, {
            entityQr: props.record.entityQr,
            linkType: "TEST",
            linkId: props.record.id
        })
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                handleShowAlertModal()
                setTimeout(() => {
                    handleCloseAlertModal()
                }, 2000);
            })
            .catch(err => {
                console.error(err);
                if (err.response && err.response!.status && err.response!.status === 403) {
                    handleLogout()
                }
            })
    };

    const [showAlert, setShowAlert] = useState(false);

    const handleCloseAlertModal = () => setShowAlert(false);
    const handleShowAlertModal = () => setShowAlert(true);

    function getModalForAlert() {
        return <Modal
            show={showAlert}
            onHide={handleCloseAlertModal}
            backdrop="static"
        >
            <Modal.Body className="text-center my-2 fs-4">
                Report Sent!
            </Modal.Body>
        </Modal>;
    }

    return (
        <tbody>
        <tr>
            <td><img alt="diagnostic-record-view-page-icon"
                     height="14rem" width="14rem" src="/external-link.png"
                     className="align-self-center"/>&nbsp;&nbsp;<a href="#/"
                                                                   className="text-primary text-decoration-none"
                                                                   onClick={e => handleShowUpdateRecordModal(props.record.recordId)}>{props.record.recordType}</a>
            </td>
            <td>{props.record.reportStatus == "NOT_REQUIRED" ? "NA" : props.record.reportStatus}</td>


            {props.isActive && props.record.reportStatus != "PENDING" && <td>
                <div className="d-flex gap-2">
                    {props.category != "Lab" && <OverlayTrigger
                        placement="right"
                        delay={{show: 250, hide: 400}}
                        overlay={renderSmsTooltip}
                    >
                        <a href="#/" onClick={e => handleSendDigital()}>
                            <img alt="diagnostic-record-view-page-icon" height="20rem" width="20rem" src="/sms.png"
                                 className="align-self-center"/>
                        </a>
                    </OverlayTrigger>}
                    {props.category != "Lab" && <>{JSON.parse(props.record.data).key &&
                        <a target="_blank" rel="noreferrer" href={"/api/s3/download/?file=" + JSON.parse(props.record.data).key}
                           className="text-success font-weight-bold"> &#x2193;</a>}</>}
                    {props.category == "Lab" && <>
                        <ReactToPrint
                            trigger={() => <a href={"#"}
                            >&#128424;</a>}
                            content={() => componentRef.current}
                        />
                        <div className="d-none">
                            <div ref={componentRef}><LabRecordPrintView uhid={props.uhid} id={props.record.id}
                                                                        printHeader={true}
                                                                        entityQr={props.entityQr}
                                                                        stateTracker={props.stateTracker} referringDr={props.referringDr}/>
                            </div>
                        </div>
                    </>}
                    <a href={"#"}
                       className="remove"
                       onClick={e => handleRemove()}
                    >X</a>
                </div>
            </td>}
            {props.isActive && props.record.reportStatus == "PENDING" && <td/>}
            {getModalForUpdateRecord()}
            {getModalForAlert()}
        </tr>
        </tbody>
    );
});

DiagnosticRecordView.displayName = "DiagnosticRecordView";